module.exports = __webpack_public_path__ + "static/media/wrinkles_forehead.09672468.svg";